export default "__VITE_ASSET__Cv7NLrK8__"